import styled from 'styled-components';
import _ from 'lodash';

import Tag from '../../../../styleguide/Tag';

const DEFAULT_TAG_FONT_FAMILY = '"Helvetica Neue", Helvetica, sans-serif';
const COLOR_RED = '#FF0024';

export const StyledStackedLabels = styled.div`
  position: ${({ theme, customStyle }) => _.get(customStyle, 'position', _.get(theme, 'labels.position', 'absolute'))};
  top: ${({ theme, customStyle }) => _.get(customStyle, 'top', _.get(theme, 'labels.top', '5px'))};
  left: ${({ theme, customStyle }) => _.get(customStyle, 'left', _.get(theme, 'labels.left', '5px'))};
  right: ${({ theme, customStyle }) => _.get(customStyle, 'right', _.get(theme, 'labels.right', 'auto'))};
  bottom: ${({ theme, customStyle }) => _.get(customStyle, 'bottom', _.get(theme, 'labels.bottom', 'auto'))};
  display: flex;
  flex-direction: ${({ theme, customStyle }) =>
    _.get(customStyle, 'flexDirection', _.get(theme, 'labels.flexDirection', 'column'))};
  align-items: ${({ theme, customStyle }) =>
    _.get(customStyle, 'alignItems', _.get(theme, 'labels.alignItems', 'flex-start'))};
  justify-content: ${({ theme, customStyle }) =>
    _.get(customStyle, 'justifyContent', _.get(theme, 'labels.justifyContent', 'flex-start'))};
  z-index: 2;
`;

export const StyledTag = styled(Tag)`
  && {
    font-family: ${({ theme, customStyle }) =>
      _.get(customStyle, 'fontFamily', _.get(theme, 'labels.fontFamily', DEFAULT_TAG_FONT_FAMILY))};
    text-transform: ${({ theme, customStyle }) =>
      _.get(customStyle, 'textTransform', _.get(theme, 'labels.textTransform', 'uppercase'))};
    padding: ${({ theme, customStyle }) => _.get(customStyle, 'padding', _.get(theme, 'labels.padding', '0 0.7em'))};
    font-size: ${({ theme, customStyle }) => _.get(customStyle, 'fontSize', _.get(theme, 'labels.fontSize', '.6em'))};
    margin: ${({ theme, customStyle }) => _.get(customStyle, 'margin', _.get(theme, 'labels.margin', '0 0 5px 0'))};
    border-radius: ${({ theme, customStyle }) =>
      _.get(customStyle, 'borderRadius', _.get(theme, 'labels.borderRadius', '2px'))};
  }
`;

export const StyledDiscountLabel = styled(StyledTag)`
  && {
    background: ${({ theme, customStyle }) =>
      _.get(customStyle, 'discount.background', _.get(theme, 'labels.discount.background', COLOR_RED))};
  }
`;
